/* eslint-disable camelcase */
import axios from 'axios'
import router from '../../router/index'
import appendHeaders from '../../utils/appendHeaders'
import handleUserNotLogged from '@utils/handleUserNotLogged'

const actions = {
  userNotLogged ({ commit }) {
    commit('USER_NOT_LOGGED')
  },
  async signUp ({ commit, dispatch, rootGetters }, payload) {
    commit('SIGNUP_FETCHING')
    const { SIGNUP: url } = rootGetters['endpoints/endpoints']

    const form = Object.keys(payload).reduce((acc, item) => {
      acc.append(item, payload[item])
      return acc
    }, new FormData())

    try {
      const { data, status } = await axios({
        method: 'post',
        url,
        data: form,
        headers: appendHeaders(),
        withCredentials: true,
        validateStatus: () => true,
      })

      const { code, errors } = data

      if (code !== 'OK' && errors) {
        const issue = { ...data, status }
        throw issue
      }
      commit('SIGNUP_SUCCESS', data)
      router.push({
        name: 'thank-you',
      })
      return data
    } catch (error) {
      commit('SIGNUP_ERROR', error)
      throw error
    }
  },
  async signUpVerification ({ commit, rootGetters }, payload) {
    commit('SIGNUP_VERIFICATION_FETCHING')
    const { SIGNUP_VERIFY: url } = rootGetters['endpoints/endpoints']

    const form = Object.keys(payload).reduce((acc, item) => {
      acc.append(item, payload[item])
      return acc
    }, new FormData())
    const { token: registerToken } = payload

    try {
      const { data, status } = await axios({
        method: 'post',
        url,
        data: form,
        headers: appendHeaders(),
        withCredentials: true,
        validateStatus: () => true,
      })

      const { code, errors } = data

      if (code !== 'OK' && errors) {
        const issue = { ...data, status }
        throw issue
      }
      commit('SIGNUP_VERIFICATION_SUCCESS', { ...data, registerToken })
      return data
    } catch (error) {
      commit('SIGNUP_VERIFICATION_ERROR', error)
      throw error
    }
  },
  async addNewWallet ({ commit, dispatch, rootGetters }, payload) {
    commit('ADD_NEW_WALLET_FETCHING')

    const { USER_WALLET_ADD: url } = rootGetters['endpoints/endpoints']

    const body = Object.keys(payload).reduce((acc, item) => {
      acc.append(item, payload[item])
      return acc
    }, new FormData())

    try {
      const { data, status } = await axios({
        method: 'post',
        url,
        data: body,
        headers: appendHeaders(),
        withCredentials: true,
        validateStatus: () => true,
      })

      const { code, errors } = data

      if (code !== 'OK' && errors) {
        const issue = { ...data, status }
        throw issue
      }
      const { data: userWallets } = data
      commit('ADD_NEW_WALLET_SUCCESS', userWallets)
      dispatch('userEdit')
    } catch (error) {
      commit('ADD_NEW_WALLET_ERROR', error)
      handleUserNotLogged(error)(dispatch)
    }
  },
  async signUpRegister ({ commit, dispatch, rootGetters }, payload) {
    commit('SIGNUP_REGISTER_FETCHING')
    const { SIGNUP_REGISTER: url } = rootGetters['endpoints/endpoints']

    const form = Object.keys(payload).reduce((acc, item) => {
      acc.append(item, payload[item])
      return acc
    }, new FormData())

    try {
      const { data, status } = await axios({
        method: 'post',
        url,
        data: form,
        headers: appendHeaders(),
        withCredentials: true,
        validateStatus: () => true,
      })

      const { code, errors } = data

      if (code !== 'OK' && errors) {
        const issue = { ...data, status }
        throw issue
      }
      const { data: currentUser } = data
      commit('SIGNUP_REGISTER_SUCCESS', currentUser)
      // this is for getting all user info's
      await dispatch('userShow')
      router.push({ name: 'dashboard' })
    } catch (error) {
      commit('SIGNUP_REGISTER_ERROR', error)
      throw error
    }
  },
  async userEdit ({ commit, dispatch, rootGetters }) {
    commit('EDIT_USER_FETCHING')

    const { EDIT_USER: url } = rootGetters['endpoints/endpoints']
    try {
      const { data, status } = await axios({
        method: 'post',
        url,
        headers: appendHeaders(),
        withCredentials: true,
        validateStatus: () => true,
      })

      const { code, errors } = data

      if (code !== 'OK' && errors) {
        const issue = { ...data, status }
        throw issue
      }
      const { data: currentUser } = data
      commit('EDIT_USER_SUCCESS', currentUser)
    } catch (error) {
      commit('EDIT_USER_ERROR', error)
      handleUserNotLogged(error)(dispatch)
    }
  },
  async logIn ({ commit, dispatch, rootGetters }, payload) {
    commit('LOGIN_FETCHING')
    const { LOGIN: url } = rootGetters['endpoints/endpoints']

    const form = Object.keys(payload).reduce((acc, item) => {
      acc.append(item, payload[item])
      return acc
    }, new FormData())

    try {
      const { data, status } = await axios({
        method: 'post',
        url,
        data: form,
        headers: appendHeaders(),
        withCredentials: true,
        validateStatus: () => true,
      })

      const { code, data: payload, errors } = data

      if (code !== 'OK' && errors) {
        const issue = { ...data, status }
        throw issue
      }
      commit('LOGIN_SUCCESS', payload)
      // this is for getting all user info's
      await dispatch('userShow')
      router.push({ name: 'dashboard' })
    } catch (error) {
      commit('LOGIN_ERROR', error)
      const { code } = error
      if (code === 'USER_ALREADY_LOGGED') {
        router.push({ name: 'dashboard' })
      }
    }
  },
  async userUpdate ({ commit, dispatch, rootGetters }, payload) {
    commit('UPDATE_USER_FETCHING')

    const body = Object.keys(payload).reduce((acc, item) => {
      acc.append(item, payload[item])
      return acc
    }, new FormData())

    const { UPDATE_USER: url } = rootGetters['endpoints/endpoints']

    try {
      const { data, status } = await axios({
        method: 'post',
        url,
        data: body,
        headers: appendHeaders(),
        withCredentials: true,
        validateStatus: () => true,
      })

      const { code, errors } = data

      if (code !== 'OK' && errors) {
        const issue = { ...data, status }
        throw issue
      }
      const { data: userUpdated } = data
      commit('UPDATE_USER_SUCCESS', userUpdated)
      dispatch('userEdit')
      return userUpdated
    } catch (e) {
      commit('UPDATE_USER_ERROR', e)
      handleUserNotLogged(e)(dispatch)
    }
  },
  async userShow ({ commit, dispatch, rootGetters }) {
    commit('SHOW_USER_FETCHING')
    const { SHOW_USER: url } = rootGetters['endpoints/endpoints']

    try {
      const { data, status } = await axios({
        method: 'post',
        url,
        headers: appendHeaders(),
        withCredentials: true,
        validateStatus: () => true,
      })

      const { code, errors } = data

      if (code !== 'OK' && errors) {
        const issue = { ...data, status }
        throw issue
      }
      const { data: currentUser } = data
      commit('SHOW_USER_SUCCESS', currentUser)
      return currentUser
    } catch (error) {
      commit('SHOW_USER_ERROR', error)
  //    handleUserNotLogged(error)(dispatch)
      // throw error
    }
  },
  async logOut ({ commit, dispatch, rootGetters }) {
    commit('LOGOUT_FETCHING')
    const { LOGOUT: url } = rootGetters['endpoints/endpoints']

    try {
      const { data, status } = await axios({
        method: 'post',
        url,
        headers: appendHeaders(),
        withCredentials: true,
        validateStatus: () => true,
      })

      const { code, errors } = data

      if (code !== 'OK' && errors) {
        const issue = { ...data, status }
        throw issue
      }
      commit('LOGOUT_SUCCESS')
      dispatch('userShow')
      router.push({ name: 'login' })
    } catch (error) {
      commit('LOGOUT_ERROR', error)
      handleUserNotLogged(error)(dispatch)
    }
  },
  async getCreditCardToken ({ commit, dispatch, rootGetters }) {
    commit('CREDIT_CARD_TOKEN_FETCHING')

    const { TRANSACTION_INITIALIZE: url } = rootGetters['endpoints/endpoints']

    try {
      const { data, status } = await axios({
        method: 'post',
        url,
        headers: appendHeaders(),
        withCredentials: true,
        validateStatus: () => true,
      })

      const { code, errors } = data

      if (code !== 'OK' && errors) {
        const issue = { ...data, status }
        throw issue
      }

      commit('CREDIT_CARD_TOKEN_SUCCESS')
      return data.data.token
    } catch (error) {
      commit('CREDIT_CARD_TOKEN_ERROR', error)
    }
  },
  async buyCredits ({ commit, dispatch, rootGetters }, payload) {
    commit('CREDIT_CARD_FETCHING')

    const { TRANSACTION_CREATE: url } = rootGetters['endpoints/endpoints']

    const currentUser = state.currentUser

    if (!payload.first_name) {
      payload.first_name = (currentUser && currentUser.first_name) || 'Unknown'
    }
    if (!payload.last_name) {
      payload.last_name = (currentUser && currentUser.last_name) || 'Unknown'
    }

    try {
      const form = Object.keys(payload).reduce((acc, item) => {
        acc.append(item, payload[item])
        return acc
      }, new FormData())

      const { data, status } = await axios({
        method: 'post',
        url,
        data: form,
        headers: appendHeaders(),
        withCredentials: true,
        validateStatus: () => true,
      })

      const { code, errors } = data

      if (code !== 'OK' && errors) {
        const issue = { ...data, status }
        throw issue
      }

      commit('CREDIT_CARD_SUCCESS')
    } catch (error) {
      commit('CREDIT_CARD_ERROR', error)
    }
  },
}

const mutations = {
  LOGIN_FETCHING (state) {
    state.fetching = true
  },
  ADD_NEW_WALLET_FETCHING (state) {
    state.fetching = true
  },
  ADD_NEW_WALLET_SUCCESS (state) {
    state.fetching = false
    state.error = null
    state.success = {
      value: true,
      message: 'Wallet added successfully!',
    }
  },
  ADD_NEW_WALLET_ERROR (state, error) {
    state.fetching = false
    state.error = { ...error }
  },
  SIGNUP_FETCHING (state) {
    state.fetching = true
  },
  UPDATE_USER_FETCHING (state) {
    state.profileFetching = true
  },
  USER_NOT_LOGGED (state) {
    state.currentUser = null
  },
  UPDATE_USER_SUCCESS (state) {
    state.profileFetching = false
    state.error = null
    state.success = {
      value: true,
      message: 'User updated successfully!',
    }
  },
  UPDATE_USER_ERROR (state, error) {
    state.profileFetching = false
    state.error = { ...error }
  },
  LOGIN_SUCCESS (state, user) {
    state.currentUser = user
    state.fetching = false
    state.error = null
  },
  SIGNUP_SUCCESS (state, user) {
    state.currentStatus = user

    state.fetching = false
    state.error = null
  },
  SIGNUP_VERIFICATION_FETCHING (state) {
    state.fetching = true
  },
  SIGNUP_VERIFICATION_SUCCESS (state, { registerToken }) {
    state.fetching = false
    // TODO: add only token instead of payload
    state.registerToken = registerToken
  },
  SIGNUP_VERIFICATION_ERROR (state, error) {
    state.fetching = false
    state.error = error
  },
  SIGNUP_REGISTER_FETCHING (state) {
    state.fetching = true
    state.error = null
  },
  SIGNUP_REGISTER_SUCCESS (state, currentUser) {
    state.fetching = false
    state.currentUser = { ...currentUser }
  },
  SIGNUP_REGISTER_ERROR (state, error) {
    state.fetching = false
    state.error = error
  },
  SHOW_USER_FETCHING (state) {
    state.fetching = true
  },
  SHOW_USER_SUCCESS (state, currentUser) {
    state.fetching = false
    state.hasFetched = true
    state.currentUser = { ...currentUser }
  },
  SHOW_USER_ERROR (state, error) {
    state.fetching = false
    state.hasFetched = true
    state.error = error
  },
  LOGIN_ERROR (state, error) {
    state.fetching = false
    state.error = error
    state.currentUser = null
  },
  SIGNUP_ERROR (state, error) {
    state.fetching = false
    state.error = error
    state.currentUser = null
  },
  EDIT_USER_FETCHING (state) {
    state.fetching = true
    state.error = null
  },
  EDIT_USER_SUCCESS (state, currentUser) {
    state.fetching = false
    state.currentUser = { ...currentUser }
    state.error = null
  },
  EDIT_USER_ERROR (state, error) {
    state.fetching = false
    state.error = { ...error }
  },
  LOGOUT_FETCHING (state) {
    state.fetching = true
    state.error = null
  },
  LOGOUT_SUCCESS (state) {
    state.fetching = false
    state.error = null
    state.currentUser = null
  },
  LOGOUT_ERROR (state, error) {
    state.fetching = false
    state.error = error
  },
  CREDIT_CARD_TOKEN_FETCHING (state) {
    state.fetching = true
    state.error = null
  },
  CREDIT_CARD_TOKEN_SUCCESS (state) {
    state.fetching = false
    state.error = null
  },
  CREDIT_CARD_TOKEN_ERROR (state, error) {
    state.fetching = false
    state.error = { ...error }
  },
  CREDIT_CARD_FETCHING (state) {
    state.fetching = true
    state.error = null
  },
  CREDIT_CARD_SUCCESS (state) {
    state.fetching = false
    state.error = null
    state.success = {
      value: true,
      message: 'Bought credits has been added to your wallet!',
    }
  },
  CREDIT_CARD_ERROR (state, error) {
    state.fetching = false
    state.error = { ...error }
  },
}

const getters = {
  currentUser: (state) => state.currentUser,
  userWallets: state => state.currentUser && state.currentUser.user_wallets,
  currentStatus: (state) => state.currentStatus,
  credits: (state) => state.currentUser && state.currentUser.credit && state.currentUser.credit.balance,
  error: (state) => state.error,
  success: (state) => state.success,
  fetching: (state) => state.fetching,
  profileFetching: state => state.profileFetching,
  registerToken: (state) => state.registerToken,
  loggedIn: (state) => !!state.currentUser,
  hasFetched: (state) => state.hasFetched,
}

const state = {
  currentStatus: null,
  success: {
    value: false,
    message: '',
  },
  currentUser: null,
  fetching: false,
  profileFetching: false,
  hasFetched: false,
  registerToken: null,
  error: null,
}

export default {
  namespaced: true,
  actions,
  getters,
  mutations,
  state,
}
